import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation } from "../../common/validation.common";
import { ProfitUnitEnum } from "../../data/enums";

export namespace AssociateMarketingValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const SubscriptionRecord = defineValidation(BaseRecordSchema);

    export const InvoiceRecord = defineValidation(BaseRecordSchema);

    export const RegistrationRecord = defineValidation(BaseRecordSchema);

    export const Create = defineValidation(
        v.object({
            name: baseVals.string(),
            phone: baseVals.phone(),
            email: v.optional(baseVals.email()),
            username: baseVals.username(),
            password: baseVals.password(),
            address: baseVals.string(),
            refcode: baseVals.string(),
            profit: v.object({
                unit: v.picklist(ProfitUnitEnum.values, "Satuan Bagi Hasil wajib diisi."),
                cost: v.number("Nilai Bagi Hasil wajib diisi."),
            }),
            agent: v.variant("isActive", [
                v.object({
                    isActive: v.literal(true),
                    outstandingLimit: v.pipe(
                        v.number("Limit Tunggakan wajib diisi."),
                        v.minValue(50_000, "Limit Tunggakan minimal Rp. 50.000"),
                    ),
                }),
                v.object({
                    isActive: v.literal(false),
                }),
            ]),
        }),
    );

    export const Update = defineValidation(
        v.object({
            name: v.exactOptional(baseVals.string()),
            phone: v.exactOptional(baseVals.phone()),
            email: v.exactOptional(baseVals.email()),
            username: v.exactOptional(baseVals.username()),
            password: v.exactOptional(baseVals.password()),
            address: v.exactOptional(baseVals.string()),
            refcode: v.exactOptional(baseVals.string()),
            profit: v.exactOptional(
                v.object({
                    unit: v.picklist(ProfitUnitEnum.values, "Satuan Bagi Hasil wajib diisi."),
                    cost: v.number("Nilai Bagi Hasil wajib diisi."),
                }),
            ),
        }),
    );
}
